<!-- 推荐医生 -->
<template>
  <label class="icon-box" @click="handleClick">
    <auth-img class="icon-img" :src="img" alt="" />
    <div class="icon-label">推荐医生</div>
  </label>
  <a-drawer
    title="推荐医生"
    placement="right"
    v-model:visible="visible"
    width="1070px"
    @close="visible = false"
  >
    <a-spin :spinning="dataLoading">
      <div class="box">
        <div class="searchBox">
          <div class="searchBar z-flex">
            <!-- <div class="area z-flex"> -->
            <div class="city">
              <a-tree-select
                ref="city"
                allowClear
                style="width: 224px"
                placeholder="选择地区"
                size="large"
                :tree-data="options.citys"
                v-model:value="queryParams.cityId"
                :dropdownStyle="dropdownStyle"
                :replace-fields="options.fieldNamesCity"
                @change="getData(true)"
                class="city"
              />
            </div>
            <div class="careerType">
              <a-select
                style="width: 224px"
                placeholder="选择职业"
                size="large"
                :options="options.careerTypeList"
                v-model:value="queryParams.careerType"
                :dropdownStyle="dropdownStyle"
              />
            </div>
            <div>
              <a-tree-select
                ref="department"
                allowClear
                style="width: 224px"
                placeholder="选择科室"
                size="large"
                :replace-fields="options.fieldNamesDepart"
                :tree-data="options.departmentList"
                v-model:value="queryParams.departmentId"
                :dropdownStyle="dropdownStyle"
                @change="getData(true)"
              />
            </div>
            <!-- </div> -->
            <div>
              <a-input
                size="large"
                v-model:value="queryParams.hospitalName"
                placeholder="搜索机构名称"
                style="width: 240px"
                @change="handleInputSearch"
                allowClear
              >
                <template #prefix>
                  <SearchOutlined class="search_icon" />
                </template>
              </a-input>
            </div>
            <div class="label">
              <a-input
                size="large"
                v-model:value="queryParams.name"
                placeholder="搜索医生姓名"
                style="width: 224px"
                @change="handleInputSearch"
                :maxlength="10"
                allowClear
              >
                <template #prefix>
                  <SearchOutlined class="search_icon" />
                </template>
              </a-input>
            </div>
          </div>
          <div v-if="curSelectCard?.name">已选择：{{ curSelectCard.name }}</div>
        </div>
        <div class="content solepop-doctor" v-if="doctorList.length">
          <div
            v-for="(it, index) in doctorList"
            :key="index"
            :class="[{ noMargin: (index + 1) % 3 === 0 }, 'card_container']"
          >
            <solePopover
              trigger="hover"
              v-bind="$attrs"
              activeKey="doctor"
              :data="recommendDoctorInfo"
              :activeGroupKey="groupId"
              :isPatChat="groupId === privateId"
              :remarkData="remarkData"
              :mouseEnterDelay="0.8"
              :initParam="doctorRemarkInitParam"
              @chatWithDoc="chatWithDoc"
              @updateRemark="handleUpdateRemark"
              :isRecommendDoctor="true"
              :isRenderOnParentNode="true"
            >
              <template #content>
                <Card
                  class="popoverCard"
                  :info="it"
                  :selectedList="selectedList"
                  :workOrderGroupInfo="workOrderGroupInfo"
                  @select="handleSelect"
                  @getRecommendDoctorInfo="handleRecommendDoctorInfo"
                />
              </template>
            </solePopover>
          </div>
        </div>
        <div class="empty" v-else><a-empty /></div>
        <div class="pagination">
          <a-pagination
            show-size-changer
            v-model:current="pagination.current"
            v-model:pageSize="pagination.pageSize"
            :total="pagination.total"
            @change="onShowSizeChange"
            @showSizeChange="onShowSizeChange"
            :show-total="total => `总共 ${total} 条`"
            :pageSizeOptions="pagination.pageSizeOptions"
          />
        </div>
      </div>
      <div class="footer">
        <a-button key="back" @click="visible = false" class="cancel">取消</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleSubmit"
          :disabled="!selectedList.length"
        >
          推荐给患者
        </a-button>
      </div>
    </a-spin>
  </a-drawer>
</template>
<script setup>
import img from '@/assets/img/chat/recommendDoc.png'
import { ref, reactive, watch, defineProps, computed, defineEmits } from 'vue'
import Card from './doctorCard.vue'
import { get } from 'lodash'
import { SearchOutlined } from '@ant-design/icons-vue'

import { debounce } from 'lodash-es'
import solePopover from '../rightInfo/solePopover/index.vue'
import {
  cityList,
  searchRecommendDoctor,
  pushDoctorsCardtoPatient,
  talkToDoctor,
  fetchRecommendDoctorDetail,
  guideRecommendedDoctorInfo,
  traceRecordRecommend,
  getCareerTypeList,
  getDepartmentByCareer
} from '@/api/chat'
const emit = defineEmits(['chatWithDoc'])

const props = defineProps({
  workOrderGroupInfo: {
    type: Object,
    default: () => {},
    required: true
  },
  groupId: {
    type: String,
    default: '',
    required: true
  },
  privateId: {
    type: String,
    default: ''
  }
})
// 前端鼠标悬浮的医生信息
const curHoverCard = ref(null)
// 人员信息协同备注
const remarkData = ref([])
const visible = ref(false)
// 医生协同备注初始化参数
const doctorRemarkInitParam = ref({})
const loading = ref(false)
const dataLoading = ref(false)
const recommendDoctorInfo = ref({})
const initPagination = {
  current: 1,
  pageSize: 9,
  total: 0,
  pageSizeOptions: ['9', '18', '27', '36']
}
const pagination = reactive({ ...initPagination })
const doctorList = ref([])
const dropdownStyle = {
  maxHeight: '66vh'
}
const options = reactive({
  departmentList: [],
  citys: [],
  fieldNamesCity: { title: 'label', key: 'value', children: 'children', value: 'value' },
  fieldNamesDepart: { title: 'name', key: 'id', children: 'childs', value: 'id' },
  careerTypeList: []
})
const initQueryParams = {
  departmentId: null,
  cityId: null,
  careerType: 1,
  name: undefined,
  hospitalName: ''
}
const queryParams = reactive({ ...initQueryParams })
const selectedList = ref([]) // 已经选中的医生
// 每次打开抽屉的时候都需要初始化
watch(
  () => visible.value,
  val => {
    if (val) {
      curSelectCard.value = {}
      selectedList.value = []
      Object.assign(queryParams, initQueryParams)
      Object.assign(pagination, initPagination)
      doctorList.value = []
      getData(true, true)
    }
  }
)
// 发起医生私聊
const chatWithDoc = async () => {
  const { doctorInfo = {} } = props.workOrderGroupInfo
  const result = await talkToDoctor({
    ucDoctorId: doctorInfo?.ucUserId ?? 0
  })
  emit('chatWithDoc', result)
}
const handleUpdateRemark = () => {
  getRecommendDoctorDetail()
  getData()
}
// 点击推荐医生
const handleClick = async () => {
  visible.value = true
  getCts()
  getCareerList()
  getDepartmentList(queryParams.careerType)
}
// 获取地区
const getCts = () => {
  cityList()
    .then(res => {
      options.citys = res
    })
    .catch(() => {
      options.citys = []
    })
}
// 获取科室列表
const getDepartmentList = careerType => {
  getDepartmentByCareer({ careerType }).then(res => {
    options.departmentList = res
  })
}
// 获取职业类型列表
const getCareerList = () => {
  getCareerTypeList().then(res => {
    options.careerTypeList = res?.map(item => ({ label: item.value, value: item.code }))
  })
}
// 推荐医生给患者
const handleSubmit = () => {
  loading.value = true
  const ucPatientId = get(props, 'workOrderGroupInfo.patientInfo.ucUserId', null)
  //  推荐成功后关闭loading
  const params = {
    doctorIds: selectedList.value,
    ucPatientId: ucPatientId,
    groupId: props.groupId
  }
  pushDoctorsCardtoPatient(params)
    .then(() => {
      visible.value = false
    })
    .finally(() => {
      loading.value = false
    })
}
// 获取推荐医生
const needSendParams = ref(false)
watch(
  () => queryParams.careerType,
  val => {
    queryParams.departmentId = null
    getDepartmentList(val)
    getData(true)
  }
)
const getData = async (initFlag, firstSearch = false) => {
  if (initFlag) {
    Object.assign(pagination, initPagination)
  }

  // 默认首次搜索 由AI推荐
  const workOrderId = computed(() => props.workOrderGroupInfo.targetWorkOrder.workOrderId)
  const businessType = computed(() => props.workOrderGroupInfo.targetWorkOrder.businessType)
  if (firstSearch && businessType.value === 10) {
    const AIParms = await guideRecommendedDoctorInfo({ workOrderId: workOrderId.value })
    const { addressId, departmentId, intentionMedicalDoctor, hasGuideRecommendedFlag } = AIParms
    needSendParams.value = hasGuideRecommendedFlag
    if (hasGuideRecommendedFlag) {
      queryParams.cityId = addressId
      queryParams.departmentId = departmentId
      queryParams.name =
        intentionMedicalDoctor && intentionMedicalDoctor !== '无' ? intentionMedicalDoctor : ''
    }
  }

  dataLoading.value = true

  const params = Object.assign({}, queryParams, {
    pageSize: pagination.pageSize,
    currPage: pagination.current
  })
  searchRecommendDoctor(params)
    .then(res => {
      doctorList.value = res.list
      pagination.current = res.currPage
      pagination.total = res.totalCount
      dataLoading.value = false
      // 后端埋点请求
      if (needSendParams.value) {
        traceRecordRecommend({
          workOrderId: workOrderId.value,
          name: queryParams.name,
          hospitalName: queryParams.hospitalName,
          departmentId: queryParams.departmentId,
          cityId: queryParams.cityId
        })
      }
    })
    .catch(() => {
      doctorList.value = []
      pagination.current = 1
      pagination.total = 0
      dataLoading.value = false
    })
}

// 选择医生后回调
const curSelectCard = ref({})
const handleSelect = (index, item) => {
  // console.log('selectedList.value', selectedList.value)
  // const list = selectedList.value || []
  // const idx = list.findIndex(it => it === index)
  // if (idx !== -1 && list.length <= 1) {
  //   selectedList.value.splice(idx, 1)
  // } else if (idx === -1 && list.length < 1) {
  //   selectedList.value.push(index)
  // } else if (idx === -1 && list.length >= 1) {
  //   message.error('一次最多选择1个医生')
  // }
  selectedList.value = [index]
  curSelectCard.value = item
}
// 改变每页条数
const onShowSizeChange = (page, pageSize) => {
  pagination.pageSize = pageSize
  pagination.current = page
  getData()
}

const handleRecommendDoctorInfo = debounce(cardInfo => {
  curHoverCard.value = cardInfo
  // 获取推荐医生详情
  getRecommendDoctorDetail()
}, 400)
// 获取推荐医生详情
const getRecommendDoctorDetail = () => {
  const { ucUserId = '' } = curHoverCard.value
  const params = {
    ucDoctorId: ucUserId
  }
  fetchRecommendDoctorDetail(params)
    .then(result => {
      const { doctorRemarkVO = {}, businessId = '', ucUserId = '' } = result
      recommendDoctorInfo.value = result
      remarkData.value = doctorRemarkVO
      doctorRemarkInitParam.value = {
        doctorId: businessId,
        ucDoctorId: ucUserId
      }
    })
    .catch(error => {
      console.log('获取推荐医生详情失败', error)
    })
}
const handleInputSearch = debounce(() => {
  getData(true)
}, 400)
</script>
<style scoped lang="scss">
@import '../../index.scss';
.box {
  height: calc(100vh - 159px);
  overflow: scroll;
  width: 100%;
  .searchBar {
    display: flex;
    flex-wrap: wrap;
    .area {
      .city,
      .careerType {
        margin-right: 10px;
      }
    }
    .label {
      margin-top: 10px;
    }
    .search_icon {
      color: rgba(0, 0, 0, 0.45);
    }
  }
  .content {
    padding-top: 12px;
    display: grid;
    grid-template-columns: repeat(3, 33.33%);
    .card_container {
      margin-right: 12px;
      margin-bottom: 12px;
      &.noMargin {
        margin-right: 0;
      }
      .container {
        height: 100%;
      }
      .popoverCard {
        height: 100%;
      }
    }
  }
  .empty {
    height: 50vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pagination {
    text-align: center;
    margin-top: 15px;
  }
}
.footer {
  padding-top: 24px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  .cancel {
    margin-right: 8px;
  }
}
</style>
<style lang="scss">
.solepop-doctor {
  .solePopover-container {
    .ant-popover-arrow {
      display: none;
    }
  }
}
</style>
